module.exports = __webpack_public_path__ + "img/marseilles-fc.03812fb3.png";